export const GET_DASHBOARD_LOADING = "GET_DASHBOARD_LOADING";
export const GET_DASHBOARD_SUCCESS = "GET_DASHBOARD_SUCCESS";
export const GET_DASHBOARD_FAILURE = "GET_DASHBOARD_FAILURE";

export const GET_CLOSE_JOB_LOADING = "GET_CLOSE_JOB_LOADING";
export const GET_CLOSE_JOB_SUCCESS = "GET_CLOSE_JOB_SUCCESS";
export const GET_CLOSE_JOB_FAILURE = "GET_CLOSE_JOB_FAILURE";

export const CLOSE_JOB_LOADING = "CLOSE_JOB_LOADING";
export const CLOSE_JOB_SUCCESS = "CLOSE_JOB_SUCCESS";
export const CLOSE_JOB_FAILURE = "CLOSE_JOB_FAILURE";
export const CLOSED_JOB_DETAILS = "CLOSED_JOB_DETAILS";
export const SET_ACTIVE_TAB = "SET_ACTIVE_TAB";

export const STILL_HIRING_LOADING = "STILL_HIRING_LOADING";
export const STILL_HIRING_SUCCESS = "STILL_HIRING_SUCCESS";
export const STILL_HIRING_FAILURE = "STILL_HIRING_FAILURE";

export const SHARE_JOB_LOADING = "SHARE_JOB_LOADING";
export const SHARE_JOB_SUCCESS = "SHARE_JOB_SUCCESS";
export const SHARE_JOB_FAILURE = "SHARE_JOB_FAILURE";

export const MARK_JOB_STORY_READ_LOADING = "MARK_JOB_STORY_READ_LOADING";
export const MARK_JOB_STORY_READ_SUCCESS = "MARK_JOB_STORY_READ_SUCCESS";
export const MARK_JOB_STORY_READ_FAILURE = "MARK_JOB_STORY_READ_FAILURE";

export const SHOW_HIRING_CERTIFICATE_DRAWER = "SHOW_HIRING_CERTIFICATE_DRAWER";
